var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"domaine"},[_c('div',{staticClass:"heart",class:{ is_animating: _vm.post.like.like },attrs:{"id":_vm.post.title + _vm.post.id},on:{"click":function($event){return _vm.like($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }